import { createStore, applyMiddleware } from 'redux';

import Immutable from 'seamless-immutable';

import { HYDRATE, createWrapper } from 'next-redux-wrapper';
import createSagaMiddleware from 'redux-saga';

import reducers from '../reducers';
import rootSaga from '../sagas';
import { logger } from '../utils/logger';

const bindMiddleware = (middleware) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line import/no-extraneous-dependencies, global-require
    const { composeWithDevTools } = require('redux-devtools-extension');
    return composeWithDevTools(applyMiddleware(...middleware));
  }

  return applyMiddleware(...middleware);
};

const reducer = (state, action) => {
  if (action.type === HYDRATE) {
    const payload = Immutable(action.payload);

    if (Object.keys(payload.getIn(['app', 'config'])).length) {
      return Immutable({ ...state, ...action.payload });
    }

    return { ...state, ...payload.without('app') };
  }

  return reducers(state, action);
};

const makeStore = (INITIAL_STATE = {}) => {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(reducer, INITIAL_STATE, bindMiddleware([sagaMiddleware, logger]));

  store.sagaTask = sagaMiddleware.run(rootSaga);

  return store;
};

export const wrapper = createWrapper(makeStore, { debug: false });

export default wrapper;
